const LETTER_MAP = "ABCDEFGHIJKLMNOPQRSTUVW";

export const validatePPSN = (ppsn) => {
  if (!ppsn || typeof ppsn !== "string") {
    return { isValid: false, error: "PPSN is required" };
  }

  const trimmed = ppsn.trim();

  if (trimmed.length === 0) {
    return { isValid: false, error: "PPSN is required" };
  }

  const normalized = trimmed.toUpperCase();

  if (!/^[0-9]{7}[A-W]{1,2}$/.test(normalized)) {
    return { isValid: false, error: "Invalid PPSN format" };
  }

  const weights = [8, 7, 6, 5, 4, 3, 2];
  let total = 0;

  for (let i = 0; i < 7; i++) {
    total += parseInt(normalized[i], 10) * weights[i];
  }

  if (normalized.length === 9) {
    const ninthChar = normalized[8];

    if (ninthChar !== "W") {
      const position = LETTER_MAP.indexOf(ninthChar) + 1;
      if (position <= 0) {
        return { isValid: false, error: "Invalid PPSN format" };
      }
      total += position * 9;
    }
  }

  const remainder = total % 23;
  const checkChar = normalized[7];
  const expectedChar = remainder === 0 ? "W" : LETTER_MAP[remainder - 1];

  if (checkChar !== expectedChar) {
    return { isValid: false, error: "Invalid PPSN check digit" };
  }

  return { isValid: true, error: null };
};
